import React from 'react';
import { PageFooterNested } from './PageFooterNested';
import { resolvePageFooterProps } from './resolvePageFooterProps';

export { resolvePageFooterProps } from './resolvePageFooterProps';

/**
 * Resolved PageFooter Data JSON, exactly as PolyR passes it from the RenderEntity `content`
 * string and as the hydration bundle reads it back from `data-poly-content`.
 *
 * Accepted fields: `socialLinks`, `bottomBarRow1Links`, `bottomBarRow2Links`, `columns`,
 * `actions`, `breadcrumbs`, `languages`, `countries` and the scalar PageFooterNestedProps.
 * Field names follow resolvePageFooterProps; anything else is ignored.
 */
export interface PageFooterDataProps {
  /** A Data field. Values are validated by resolvePageFooterProps at render time. */
  [field: string]: unknown;
}

/**
 * PageFooterData - registered render adapter for a PageFooter Data object.
 *
 * Applies resolvePageFooterProps to the Data JSON and renders PageFooterNested, so PolyR SSR
 * and browser hydration run the same transform under the `PageFooterData` componentType.
 * Not a CMS block: it has no block template and no authorable fields.
 */
export const PageFooterData: React.FC<PageFooterDataProps> = (props) => (
  <PageFooterNested {...resolvePageFooterProps(props)} />
);
